import React, { useEffect, useState } from "react";
import { CancelOrder, CancelOrderByAdmin, createdPass, PostOrderAdmin } from "../../../../services/OrderService";
import User, { UserRole } from "../../../../models/User";
import { PostUserAdmin, PutUserAdmin, updateActiveUser } from "../../../../services/UserService";
import { ActiveType } from "../../../../models/Login";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useUpdateActiveUserAdmin(props: { reload: () => void }) {
	const { openAlertDialog } = useAlertDialog();
	const ActiveUserAd = async (id: string, status: boolean) => {
		try {
			await updateActiveUser(id, status);
			openAlertDialog?.(AlertType.Success, "Successfully!", () => {
				props.reload();
			});
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "Fail!");
		}
	};

	return {
		ActiveUserAd,
	};
}
